import { Clear, Close } from "@mui/icons-material";
import {
  Box,
  Button,
  DialogContent,
  DialogTitle,
  Paper,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import { Form } from "formik";

export const StyledForm = {
  Input: styled("div")(({ theme }) => ({
    display: "inline-flex",
    marginRight: 20,
    width: 275,
  })),
  Button: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
    height: "fit-content",
  })),
  ButtonContainer: styled("div")(({ theme }) => ({
    display: "flex",
  })),
  Container: styled(Form)(({ theme }) => ({
    width: "100%",
  })),
  DocumentsContainer: styled("div")({
    display: "flex",
    flex: 1,
    backgroundColor: "#f5f5f5",
  }),

  DocumentContainer: styled("div")({
    display: "flex",
    justifyContent: "center",
    flex: 3,
  }),

  DialogContentStyled: styled(DialogContent)({
    display: "flex",
    height: "100vh",
    padding: "0px",
  }),
};

export const StyledFormHeader = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),
  CloseIcon: styled(Close)(({ theme }) => ({
    color: "white",
    cursor: "pointer",
    width: 25,
    height: 25,
  })),
  text: {
    color: "white",
    fontWeight: "bold",
    textTransform: "upperCase",
  },
};

export const StyledImportIetContainer = {
  Title: styled(Typography)({
    marginBottom: 20,
  }),
  PaperContainer: styled(Paper)({
    display: "flex",
    padding: 20,
  }),
  ProcessingFileContainer: styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  }),
};

export const StyledImportIetError = {
  ButtonContainer: styled("div")({
    display: "flex",
    justifyContent: "center",
    marginTop: 40,
  }),

  PaperContainer: styled(Paper)({
    margin: "40px auto",
    padding: 40,
  }),

  TypographyContainer: styled("div")({
    display: "flex",
    justifyContent: "center",
    paddingBottom: 15,
  }),

  ExitButton: styled(Button)({
    color: "red",
    border: "1px solid red",
    marginLeft: 10,
  }),
};

export const StyledImportIetForm = {
  FormContainer: styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "80%",
  }),

  Input: styled("div")({
    marginRight: 20,
    width: "100%",
  }),

  ButtonStyled: styled(Button)(({ theme }) => ({
    margin: theme.spacing(2.5),
  })),

  DropzoneContainer: styled("div")({
    display: "flex",
    alignItems: "stretch",
    height: "20em",
  }),

  DownloadFileButton: styled("div")({
    display: "flex",
    justifyContent: "flex-start",
  }),

  SubmitButtonContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
  }),
};

export const StyledFormContainerCard = {
  Container: styled("div")({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflow: "auto",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 2,
    paddingBottom: 5,
  }),
  Card: styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: 10,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    cursor: "pointer",
    "&.active": {
      backgroundColor: theme.palette.primary.main,
    },
    "&.disabled": {
      cursor: "default",
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  })),
  Date: styled(Typography)({
    alignSelf: "flex-end",
    color: "grey",
  }),

  TextActive: {
    color: "white",
  },
};

export const StyledEspecialidadAdd = {
  RowContainer: styled("div")({
    display: "flex",
    justifyContent: "space-between",
  }),

  Input: {
    flex: 1,
    marginBottom: 15,
  },
};

export const StyledEspecialidadCard = {
  Container: styled("div")({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    marginBottom: 15,
  }),

  Card: styled("div")({
    display: "flex",
    marginTop: 10,
    marginBottom: 5,
  }),

  InfoContainer: styled(Paper)({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: 10,
    padding: 10,
    paddingLeft: 15,
    paddingRight: 15,
  }),

  RowContainer: styled("div")({
    display: "flex",
    justifyContent: "space-between",
  }),

  ActionContainer: styled(Paper)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    marginLeft: 8,
    paddingLeft: 15,
  }),

  Button: styled(Tooltip)(({ theme }) => ({
    cursor: "pointer",
    marginRight: 15,
    color: theme.palette.text.primary,
  })),

  DisabledButton: styled(Tooltip)({
    marginRight: 15,
    color: "grey",
  }),
};

export const StyledEspecialidadContainer = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    marginBottom: 20,
  })),

  ErrorText: styled(Typography)(({ theme }) => ({
    marginBottom: 10,
  })),
};

export const StyledFpaAuthorizationDialog = {
  TitleContainer: styled(DialogTitle)(({ theme }) => ({
    textAlign: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  ContentContainer: styled(DialogContent)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
    marginBottom: 20,
  })),
};

export const StyledFpaConfirmDialog = {
  TitleContainer: styled(DialogTitle)(({ theme }) => ({
    textAlign: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  ContentContainer: styled(DialogContent)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  })),
};

export const StyledPrestacionesAdd = {
  Input: styled("div")(({ theme }) => ({
    marginBottom: 15,
  })),

  CircularLoadingContainer: styled("div")({
    marginTop: 50,
    marginBottom: 150,
  }),
};
export const StyledPrestacionesCard = {
  Container: styled("div")({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    marginBottom: 15,
  }),

  Card: styled("div")({
    display: "flex",
    marginTop: 10,
    marginBottom: 5,
  }),

  InfoContainer: styled(Paper)({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: 10,
  }),

  ActionContainer: styled(Paper)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    marginLeft: 8,
    paddingLeft: 15,
    width: "fit-content",
  }),

  PrestacionesContainer: styled("div")({
    display: "flex",
    justifyContent: "space-between",
    padding: 5,
    paddingLeft: 15,
    paddingRight: 15,
  }),

  PrestacionesSolicitadasContainer: styled("div")({
    display: "flex",
    justifyContent: "space-between",
    borderRadius: 10,
    padding: 5,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "#f7f7f7",
    border: "solid",
    borderWidth: "thin",
    borderColor: "lightGrey",
  }),

  RowContainer: styled("div")({
    display: "flex",
    justifyContent: "space-between",
    width: "70%",
  }),

  button: {
    cursor: "pointer",
    marginRight: 15,
  },

  disabledButton: {
    marginRight: 15,
    color: "grey",
  },
};
export const StyledPrestacionesContainer = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
  }),

  PrestacionesErrorText: styled(Typography)({
    marginBottom: 10,
  }),
};
export const StyledEditFormHeader = {
  TitleContainer: styled("div")({
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    marginLeft: 20,
    marginRight: 40,
  }),

  Text: styled(Typography)({
    color: "white",
  }),

  Name: styled(Typography)({
    fontWeight: "bold",
  }),
};
export const StyledIdrConfirmDialog = {
  TitleContainer: styled(DialogTitle)(({ theme }) => ({
    textAlign: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  ContentContainer: styled(DialogContent)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 20,
  }),

  Text: styled(Typography)({
    whiteSpace: "pre-line",
  }),
};

export const StyledInternmentContainer = {
  InternmentContainerWrapper: styled("div")({
    display: "flex",
  }),

  internmentInput: {
    width: "45%",
    marginLeft: "5px",
  },
};

export const StyledEditFormHeaders = {
  Container: styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  TitleContainer: styled(Box)({
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    marginLeft: 20,
    marginRight: 40,
  }),

  Text: styled(Typography)({
    color: "white",
  }),

  NameText: styled(Typography)({
    color: "white",
    fontWeight: "bold",
  }),

  CloseIcon: styled(Close)({
    color: "white",
    cursor: "pointer",
    width: 25,
    height: 25,
  }),
};

export const StyledCommonForms = {
  Container: styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  FormContainer: styled(Form)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  }),

  Icon: styled("div")({
    width: 40,
    height: 40,
  }),

  FormLoadingContainer: styled("div")({
    marginTop: 100,
  }),

  FieldContainer: styled("div")({
    display: "flex",
    flexDirection: "column",
    paddingLeft: 40,
    paddingRight: 40,
    overflow: "auto",
  }),

  ActionsContainer: styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 2,
    backgroundColor: "white",
    padding: 10,
    boxShadow: "0px 0 5px lightGrey",
  })),

  RowContainer: styled("div")({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 15,
    marginTop: 15,
  }),

  LeftColumnContainer: styled("div")({
    display: "flex",
    width: "47%",
  }),

  RightColumnContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
    width: "47%",
  }),

  RightColumnContainerCheckBoxStart: styled("div")({
    display: "flex",
    justifyContent: "flex-start",
    width: "47%",
  }),

  input: {
    flex: 1,
  },

  AppointmentControl: styled("div")({
    display: "flex",
    alignItems: "center",
    flex: 1,
  }),

  addAppointment: {
    marginLeft: 5,
    width: 50,
    height: 50,
    cursor: "pointer",
  },

  addAppointmentDisabled: {
    marginLeft: 5,
    width: 50,
    height: 50,
    color: "grey",
  },
};

export const StyledFpaAppointmetCard = {
  Container: styled(Box)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    marginBottom: 15,
  }),

  Card: styled(Box)({
    display: "flex",
    marginTop: 10,
    marginBottom: 5,
  }),

  InfoContainer: styled(Paper)({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: 10,
  }),

  ActionContainer: styled(Paper)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    marginLeft: 8,
    paddingLeft: 15,
  }),

  TurnosContainer: styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    padding: 5,
    paddingLeft: 15,
    paddingRight: 15,
  }),

  RowContainer: styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    width: "70%",
  }),

  Button: styled(Clear)(({ disabled }) => ({
    cursor: disabled ? "default" : "pointer",
    marginRight: 15,
    color: disabled ? "grey" : "inherit",
  })),
};
